/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentAssets.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Asset API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, January 21, 2019 - 07:29:03 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Assets = {
    all: (start, count, rigid, rigsectionid) => requests.get(`/Assets?start=${start}&count=${count}&rigid=${rigid}&rigsectionid=${rigsectionid}`),
    get: assetid => requests.get(`/Asset/${assetid}`),
    create: asset => requests.post(`/Assets`, asset),
    update: (assetid, asset) => requests.put(`/Asset/${assetid}`, asset),
    delete: assetid => requests.del(`/Asset/${assetid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentAssets.js